const PaymentIcon = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <svg
        width={35}
        height={35}
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M32.0846 17.5C32.0846 25.554 25.5554 32.0833 17.5013 32.0833C9.44715 32.0833 2.91797 25.554 2.91797 17.5C2.91797 9.4458 9.44715 2.91663 17.5013 2.91663C25.5554 2.91663 32.0846 9.4458 32.0846 17.5Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M21.4532 14.6724C21.3087 13.5602 20.0316 11.7632 17.7353 11.7631C15.0671 11.7631 13.9445 13.2408 13.7167 13.9797C13.3613 14.968 13.4323 16.9999 16.5597 17.2214C20.4691 17.4985 22.0352 17.9599 21.836 20.3525C21.6366 22.7449 19.4575 23.2618 17.7353 23.2063C16.013 23.151 13.1953 22.3599 13.0859 20.2318M17.462 10.2054V11.7684M17.462 23.192V24.7887"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export default PaymentIcon;
